import 'react-step-progress/dist/index.css';
import * as React from 'react';
import * as styles from './style.scss';
import { Fallback, Modal } from 'components/common';
import { IState } from 'redux/global-reducers';
import { Lang } from 'constants/enum';
import { ListOfSteps } from './Common/helper';
import { RouteComponentProps } from 'react-router';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import {
  changeEkycParams,
  checkBlockIp,
  checkContactInfoIsExisted,
} from './action';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import Ekyc from 'screens/KisEkyc/EkycSDK';
import Step1 from './Step1';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import StepProgressBar from 'react-step-progress';
import classNames from 'classnames';
import config from 'config';
import { IChannelID } from 'interfaces/reducers';
import { dispatchChannelIDtoStore } from 'redux/global-actions';
import { FailIcon } from 'assets/svg';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}
export interface IEkycScreenProps
  extends React.ClassAttributes<AppComponent>,
    WithNamespaces,
    RouteComponentProps {
  readonly forceUsingEnglish?: boolean;
  readonly forceUsingVietnamese?: boolean;

  readonly lang: IState['lang'];
  readonly dataChannelID: IState['dispatchChannelIDtoStore'];
  readonly config: IState['config'];
  readonly checkExistedResult: IState['checkExistedResult'];
  readonly ekycParams: IState['ekycParams'];

  readonly changeEkycParams: typeof changeEkycParams;
  readonly dispatchChannelIDtoStore: typeof dispatchChannelIDtoStore;
  readonly checkContactInfoIsExisted: typeof checkContactInfoIsExisted;
  readonly checkBlockIp: typeof checkBlockIp;
}

export interface IAppState {
  readonly nextStep: string;
  readonly errorMessage: string;
  readonly isShowModalFailStep3: boolean;
  readonly checkInfoNotExist: boolean;
  readonly deviceIp: string;
}

class AppComponent extends React.Component<IEkycScreenProps, IAppState> {
  private isMobile: boolean = false;
  constructor(props: IEkycScreenProps) {
    super(props);
    this.state = {
      nextStep: ListOfSteps.SelectInvestor,
      errorMessage: '',
      isShowModalFailStep3: false,
      checkInfoNotExist: false,
      deviceIp: '',
    };

    this.isMobile = detectMob();

    const urlParams = new URLSearchParams(props.history.location.search);
    const channel = urlParams.get('channel');

    if (channel) {
      props.history.push('/ekyc');
      props.changeEkycParams({
        channelId: channel.toLocaleUpperCase(),
        // referrerIdName: channel.toLocaleUpperCase(),
      });
    }
  }

  componentDidMount() {
    FingerprintJS.load()
      .then((fp) => {
        return fp.get();
      })
      .then((result) => {
        this.props.checkBlockIp({ deviceIp: result.visitorId });
        this.setState({ deviceIp: result.visitorId });
      })
      .catch((error) => {
        console.log(error);
      });
    this.getListChannelID();
  }

  componentDidUpdate(prevProps: IEkycScreenProps) {
    if (
      prevProps.checkExistedResult !== this.props.checkExistedResult &&
      this.props.checkExistedResult.message
    ) {
      if (this.props.checkExistedResult.message === 'Success') {
        this.setState({ checkInfoNotExist: true });
      } else if (this.props.checkExistedResult.message !== 'Success') {
        this.setState({ isShowModalFailStep3: true });
      }
    }
    if (prevProps.dataChannelID !== this.props.dataChannelID) {
      const urlParams = new URLSearchParams(this.props.history.location.search);
      const clientIntroducer = urlParams.get('clientIntroducer');
      const inputCusChannelID = urlParams.get('inputCusChannelID');
      if (clientIntroducer && inputCusChannelID) {
        if (
          this.props.dataChannelID.find(
            (ele) =>
              ele.inputCusChannelID === inputCusChannelID &&
              ele.clientIntroducer === clientIntroducer
          ) != null
        ) {
          this.props.changeEkycParams({
            referrerIdName: clientIntroducer.toLocaleUpperCase(),
            channelId: inputCusChannelID,
            notModifiedIDBroker: true,
          });
        }
      }
    }
  }

  private validateStep3 = async () => {
    await this.props.checkContactInfoIsExisted({
      numberID: this.props.ekycParams.identifierId,
      phoneNumber: this.props.ekycParams.phoneNo,
      deviceIp: this.state.deviceIp,
    });
    if (this.state.checkInfoNotExist) {
      return this.validateStep(ListOfSteps.PersonalInfoDone);
    } else {
      return false;
    }
  };

  render() {
    const { t } = this.props;

    const useEnglish =
      this.props.forceUsingEnglish && this.props.lang === Lang.EN;
    const useVietnamese =
      this.props.forceUsingVietnamese && this.props.lang === Lang.VI;
    const ekyc = (
      <StepProgressBar
        startingStep={0}
        onSubmit={this.onFormSubmit}
        previousBtnName={t('BACK 1')}
        nextBtnName={t('NEXT')}
        primaryBtnClass={styles.NextButton}
        secondaryBtnClass={styles.BackButton}
        buttonWrapperClass={styles.ButtonWrapper}
        contentClass={this.isMobile ? styles.EkycMobile : ''}
        steps={[
          {
            label: t('Scan ID Card/ Passport'),
            subtitle: '',
            name: '',
            content: <Step1 allowToNextStep={this.allowToNextStep} />,
            validator: () => this.validateStep(ListOfSteps.InvestorGuide),
          },
          {
            label: t('Face Recognition'),
            subtitle: '',
            name: '',
            content: <Ekyc allowToNextStep={this.allowToNextStep} />,
            validator: () => this.validateStep(ListOfSteps.SDKDone),
          },
          {
            label: t('Personal Information'),
            subtitle: '',
            name: '',
            content: <Step3 allowToNextStep={this.allowToNextStep} />,
            validator: () => {
              return Boolean(this.validateStep3());
            },
          },
          {
            label: t('Service Registration'),
            subtitle: '',
            name: '',
            content: <Step4 allowToNextStep={this.allowToNextStep} />,
            validator: () =>
              this.validateStep4(ListOfSteps.UploadSignatureAndImgDone),
          },
          {
            label: t('OTP Authentication'),
            subtitle: '',
            name: '',
            content: <Step5 allowToNextStep={this.allowToNextStep} />,
            validator: () => this.validateStep(''),
          },
        ]}
      />
    );
    return (
      <div
        className={classNames(styles.Ekyc, this.state.nextStep, {
          [styles.EkycMobile]: this.isMobile,
        })}
      >
        {!this.isMobile && (
          <div className={styles.LogoSection}>
            <div className={styles.Logo} />
          </div>
        )}
        {!this.isMobile && (
          <div className={styles.Crossbar}>
            <div className={styles.CrossbarLeft} />
            <div className={styles.CrossbarRight} />
          </div>
        )}
        {useEnglish && ekyc}
        {useVietnamese && ekyc}
        {!this.props.forceUsingEnglish &&
          !this.props.forceUsingVietnamese &&
          ekyc}
        <div className={styles.ErrorMessage}>
          <p>{this.state.errorMessage}</p>
        </div>
        <Modal
          size="sm"
          show={this.state.isShowModalFailStep3}
          className={styles.modalContainer}
        >
          <div className={styles.modalFailed}>
            <div
              style={{
                fontWeight: 'bold',
                display: 'flex',
                justifyContent: 'flex-end',
                padding: 15,
              }}
            >
              <div
                onClick={() => this.setState({ isShowModalFailStep3: false })}
                style={{ fontSize: 20, fontWeight: 'bold' }}
              ></div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <FailIcon />
              <div className={styles.registerFailedText}>
                {t('Register Failed')}
              </div>
              <div className={styles.registerFailedText1}>
                {t('This ID is existed')}
              </div>
            </div>
            <a href={'/ekyc'}>
              <div className={styles.confirmText}>{t('Confirm')}</div>
            </a>
          </div>
        </Modal>
      </div>
    );
  }

  private getListChannelID() {
    if (config.campaignUrl != null) {
      fetch(config.campaignUrl, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
          Timeout: '5000',
        },
      })
        .then((response) => {
          if (!response.ok) {
            // *** Check errors
            throw new Error('HTTP status ' + response.status);
          }
          return response.text(); // *** Read the TEXT of the response
        })
        .then((dataSourceText) => {
          // *** More accurate name
          const dataSource: IChannelID[] = JSON.parse(dataSourceText);

          this.props.dispatchChannelIDtoStore(dataSource);
        })
        .catch((error) => {
          console.log('Please check your internet connection then try again!');
        });
    }
  }

  private validateStep4 = (step: string) => {
    const { t } = this.props;
    if (step !== this.state.nextStep) {
      if (this.state.nextStep === ListOfSteps.UploadSignatureDone) {
        this.setState({
          errorMessage: t('Please upload a photo of your signature'),
        });
      } else if (this.state.nextStep === ListOfSteps.UploadConfirmImgDone) {
        this.setState({
          errorMessage: t('Please confirm this is your signature'),
        });
      } else if (this.state.nextStep === ListOfSteps.UploadSignature) {
        this.setState({
          errorMessage: t(
            'Please upload your signature photo and confirm your signature'
          ),
        });
      }
    } else {
      this.setState({ errorMessage: '' });
    }
    return step === this.state.nextStep;
  };

  private validateStep = (step: string) => {
    return step === this.state.nextStep;
  };

  private allowToNextStep = (step: string) => {
    this.setState({ nextStep: step });
  };

  private onFormSubmit = () => {};
}

const mapStateToProps = (state: IState) => ({
  lang: state.lang,
  dataChannelID: state.dispatchChannelIDtoStore,
  config: state.config,
  checkExistedResult: state.checkExistedResult,
  ekycParams: state.ekycParams,
});

const mapDispatchToProps = {
  dispatchChannelIDtoStore,
  changeEkycParams,
  checkContactInfoIsExisted,
  checkBlockIp,
};

const EkycScreen = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(AppComponent)
  ),
  Fallback,
  handleError
);

export default EkycScreen;



// WEBPACK FOOTER //
// ./src/screens/KisEkyc/index.tsx